import { createRoute } from "@tanstack/react-router";

import { signedInRoute, teamRoute } from "../../platform/routes";
import { MembersScreen } from "./MembersScreen";
import { NewTeamScreen } from "./NewTeamScreen";

export const membersRoute = createRoute({
  getParentRoute: () => teamRoute,
  path: "members",
  component: MembersScreen,
});


/** `/teams/new`: a static segment beside `teams/$teamId`, whose UUID parse refuses "new". */
export const newTeamRoute = createRoute({
  getParentRoute: () => signedInRoute,
  path: "teams/new",
  component: NewTeamScreen,
});
